<template>
  <div>
    <div class="map-upload">
      <div class="map-upload__info">
        Вы можете выбрать участок карты вместо загрузки подложки.<br />
        Масштаб будет задан автоматически.
      </div>
      <div class="gmap">
        <p class="gmap__title">Google Maps</p>
        <GmapMap
          ref="gmap"
          :center="{ lat: coords[0], lng: coords[1] }"
          :zoom="10"
          map-type-id="terrain"
          style="min-width: 540px; height: 540px"
        >
        </GmapMap>
      </div>
    </div>
    <div class="map-upload__footer">
      <main-button @click="use()" v-if="busy == false">Загрузить участок</main-button>
      <main-button v-else disabled><i class="fa fa-spinner fa-spin fa-fw"></i> Идёт загрузка...</main-button>
      <main-button color="link" class="news-footer-button" @click="$emit('onCancelClick')">Отмена</main-button>
    </div>
  </div>
</template>

<script>
import MainButton from "../../components/ui/MainButton.vue";
export default {
  name: "mapUpload",

  components: { MainButton },

  data() {
    return {
      busy: false,
      url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
      obj: {},
      coords: [54.82896654088406, 39.831893822753904],
      OSMbounds: null,
      OSMcenter: [54.82896654088406, 39.831893822753904],
      OSMZoom: 10,
    };
  },
  props: {
    proj_id: Number,
    substrate: Object,
    city: Object,
  },
  mounted() {
    if (this.city && this.city.LONGITUDE && this.city.LATITUDE) {
      this.coords = [parseFloat(this.city.LATITUDE), parseFloat(this.city.LONGITUDE)];
      this.OSMcenter = [parseFloat(this.city.LATITUDE), parseFloat(this.city.LONGITUDE)];
    }
  },
  methods: {
    zoomUpdated(zoom) {
      this.OSMZoom = zoom;
    },
    centerUpdated(center) {
      this.OSMcenter = center;
    },
    boundsUpdated(bounds) {
      this.OSMbounds = bounds;
    },

    use() {
      this.busy = true;
      const lat = this.$refs.gmap.$mapObject.getCenter().lat();
      const lng = this.$refs.gmap.$mapObject.getCenter().lng();
      const zoom = this.$refs.gmap.$mapObject.getZoom();
      const type = this.$refs.gmap.$mapObject.getMapTypeId();
      const northEastLat = this.$refs.gmap.$mapObject.getBounds().getNorthEast().lat();
      const northEastLng = this.$refs.gmap.$mapObject.getBounds().getNorthEast().lng();
      const southWestLat = this.$refs.gmap.$mapObject.getBounds().getSouthWest().lat();

      const k = 1280 / (this.getDistanceFromLatLonInKm(southWestLat, northEastLng, northEastLat, northEastLng) * 1000);

      const link =
        "https://maps.googleapis.com/maps/api/staticmap?center=" +
        lat +
        "," +
        lng +
        "&zoom=" +
        zoom +
        "&size=540x540&scale=2&format=png32&maptype=" +
        type +
        "&language=ru&key=AIzaSyAm5QsJ9eiXC3KQ5VW3XXKyzc-ptJbtZh0";

      this.$http
        .post("mapeditor/substrate-map-upload?proj_id=" + this.proj_id, {
          file: link,
          k: k,
        })
        .then((response) => {
          this.busy = false;
          this.$emit("substrateUpdate", response.data);
          this.$bvModal.hide("mapUpload");
        })
        .catch((e) => {
          this.busy = false;
          alert(e.response.data);
        });
    },
    getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
      const R = 6371; // Radius of the earth in km
      const dLat = this.deg2rad(lat2 - lat1); // deg2rad below
      const dLon = this.deg2rad(lon2 - lon1);
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const d = R * c; // Distance in km
      return d;
    },
    deg2rad(deg) {
      return deg * (Math.PI / 180);
    },
    calculateTheDistance(A1, A2, B1, B2) {
      const d = Math.sqrt(Math.pow(A1 - A2, 2) + Math.pow(B1 - B2, 2));
      return d;
    },
  },
};
</script>

<style>
.map-upload {
  padding: 0 24px 32px 24px;
}

.map-upload__info {
  font-family: "Inter", sans-serif;
  border: 1px solid var(--primary-color);
  border-radius: 4px;
  display: flex;
  align-items: flex-start;
  padding: 8px 16px;
  background-color: color-mix(in srgb, var(--primary-color) 10%, transparent);
  font-size: 14px;
  line-height: 20px;
}

.gmap__title {
  padding: 16px 0;
  font-family: "Inter", sans-serif;
  color: var(--black-color);
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 0;
}

.map-upload__footer {
  background-color: var(--background-color);
  padding: 16px 24px;
  display: flex;
  gap: 16px;
}
</style>
